export default "__VITE_ASSET__CoSiyVRG__"